import React from 'react';

import { Box, Button, Heading, Text } from '@opendoor/bricks/core';

import { OD_HOMEPAGE_URL } from '../../helpers/globals';

const SignUpComplete: React.FC = (props: any) => {
  const { outOfMarket } = props.location.state;
  const redirectToHome = () => {
    window.location.assign(`${OD_HOMEPAGE_URL}/w/partner/builder`);
  };

  return (
    <Box padding="10px" margin="auto" width={['100%', '100%', '33%', '33%']} textAlign="center">
      <img
        src="https://imgdrop.imgix.net/14238827a66c46ecbf8dd32982983700.svg"
        alt="Complete Icon"
      />
      <Heading size="UNSAFE_h4" as="h4" padding="15px 0">
        Thank you for your interest in Opendoor’s Sales Associate solutions.
      </Heading>
      <Text padding="15px 0">
        {outOfMarket
          ? 'Opendoor doesn’t currently serve your market, but we’ll let you know as soon as we do!'
          : 'We’ll be in touch shortly!'}
      </Text>
      <Button
        onClick={redirectToHome}
        analyticsName="partnership-dashboard-fe-sign-up-back-to-homepage"
        aria-label=""
      >
        Back to Homepage
      </Button>
    </Box>
  );
};

export default SignUpComplete;
